// extracted by mini-css-extract-plugin
module.exports = {"alert":"Alert-module__alert___14cRW","error":"Alert-module__error___1atC8","closebtn":"Alert-module__closebtn___3odFJ","hide":"Alert-module__hide___tXk-N"};